// ABOUTME: UI component for SharePoint folder navigation breadcrumbs
// ABOUTME: Displays navigation path with clickable breadcrumbs for folder navigation
/* eslint-disable react/prop-types */

import { Box, Button, FolderIcon, Typography } from '@ds/coolshop';
import React from 'react';

import type { IItemBreadcums } from '../api/types';

type IBreadcrumbNavigationProps = {
    readonly breadcrumbs: readonly IItemBreadcums[];
    readonly onBreadcrumbClick: (index: number) => void;
};

export const BreadcrumbNavigation: React.FC<IBreadcrumbNavigationProps> = React.memo(
    ({ breadcrumbs, onBreadcrumbClick }) => {
        if (breadcrumbs.length === 0) {
            return null;
        }

        return (
            <Box display="flex">
                {breadcrumbs.map((item, index) => {
                    const isLast = index === breadcrumbs.length - 1;
                    const key = `breadcrumb-${item.driveItemId}-${item.name
                        .replace(/\s+/g, '-')
                        .toLowerCase()}`;

                    if (isLast) {
                        return (
                            <Box display="flex" gap={1} alignItems="center">
                                <FolderIcon fontSize="small" color="primary" />
                                <Typography key={key} variant="button" color="primary">
                                    {item.name}
                                </Typography>
                            </Box>
                        );
                    }

                    return (
                        <Box alignItems="center" gap={0} display="flex">
                            <Button
                                key={key}
                                onClick={() => onBreadcrumbClick(index)}
                                startIcon={<FolderIcon fontSize="small" />}
                            >
                                {item.name}
                            </Button>
                            <Box pr={1}>/</Box>
                        </Box>
                    );
                })}
            </Box>
        );
    },
);

BreadcrumbNavigation.displayName = 'BreadcrumbNavigation';
